"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOccasionStencil = exports.occasionStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.occasionStencilDefinition = {
    view: {
        label: 'Occasion',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: ['title', 'teaser'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'featured-media',
                            'label',
                            'uri-title',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'standalone',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['content-categories'],
            },
        ],
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.labelPropertyDefinition.name]: {
            ...properties_1.labelPropertyDefinition,
            view: { label: 'Internal Title' },
        },
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'maxLength',
                    argument: 250,
                },
            ],
        },
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: false,
        },
        [properties_1.uriTitlePropertyDefinition.name]: {
            ...properties_1.uriTitlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'maxLength',
                    argument: 250,
                },
                {
                    name: 'pattern',
                    argument: '^[^#%?&/,]*$',
                },
            ],
        },
    },
    localizations: [],
    roles: [],
    spaces: ['cartoons'],
    name: 'occasion',
};
const isOccasionStencil = (stencil) => {
    return stencil.name === exports.occasionStencilDefinition.name;
};
exports.isOccasionStencil = isOccasionStencil;
//# sourceMappingURL=data:application/json;base64,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